module.exports = __webpack_public_path__ + "img/animation_icon_2.2d65a6d0.webp";